import { useNavigate } from 'react-router-dom';

import { confirmLeaveWithoutSaving } from '../../common/confirmLeaveWithoutSaving';
import { pathToUrl } from '../../utils/router';
import { PageRoutesEnum } from '../../utils/routes';

export const useOpenCvSuggestionsPage = (candidateId: string) => {
  const navigate = useNavigate();
  return (dirty: boolean) => {
    const open = () => navigate(pathToUrl(PageRoutesEnum.candidateCvSuggestions, { id: candidateId }));
    if (!dirty) return open();
    confirmLeaveWithoutSaving('Accepting CV suggestions writes to the saved candidate record.', open);
  };
};
